import React from 'react';
import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { LogoIcon, NavBarListItem } from '../styles/componentStyled';
import { AppBar, Box, Toolbar, TextField, IconButton, Drawer, List, ListItemText } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import Autocomplete from '@mui/material/Autocomplete';



const Navbar = ({ posts }) => {
    const navigate = useNavigate();
    const handleChange = (event, newValue) => {
        if (newValue) {
            navigate(`/single/${newValue.slug}`); // Adjust 'ai-news' as needed
        }
    };
    // useLocation is hook  because of that It must be called at top level function component
    const location = useLocation();
    // Page Routes data
    const pages = [{ name: 'Home', href: '/' }, { name: 'AI Blog', href: '/ai-blog' }, { name: 'AI Tools', href: '/ai-tools' }, { name: 'AI Trader', href: '/ai-trader' }, { name: 'Webinars', href: '/webinar' }];

    // Toggle state for mobile menu (Drawer)
    const [toggleMenu, setToggleMenu] = useState(false);
    const toggleNavMenu = () => {
        setToggleMenu(!toggleMenu);
    };

    const [searchInput, setSearchInput] = useState('');
    const autoComplete = (
        <Autocomplete
            disablePortal
            freeSolo
            openOnFocus
            options={Array.isArray(posts) ? posts : []}
            onChange={(event, newValue) => {
                if (newValue?.slug) {
                    navigate(`/single/${newValue.slug}`);
                }
            }}
            filterOptions={(options, { inputValue }) =>
                options.filter(option =>
                    option.title?.toLowerCase().includes(inputValue.toLowerCase()) ||
                    option.content?.toLowerCase().includes(inputValue.toLowerCase())
                )
            }
            getOptionLabel={(option) =>
                typeof option === 'string' ? option : option.title || ''
            }
            renderInput={(params) => (
                <TextField
                    {...params}
                    variant="outlined"
                    color="secondary"
                    size="small"
                    focused
                    placeholder="Search"
                    hiddenLabel
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            const input = e.target.value.trim();
                            if (input) {
                                navigate(`/search?query=${encodeURIComponent(input)}`);
                            }
                        }
                    }}
                />
            )}
            noOptionsText="No results found"
            ListboxProps={{
                sx: {
                    '& .MuiAutocomplete-option': {
                        color: 'black',
                        fontSize: '9px'
                    },
                },
            }}
        />
    );



    return (
        <AppBar color='primary' position='sticky' >
            <Toolbar>

                <IconButton href='/'  >
                    <LogoIcon
                        component="img"
                        src="/images/top500-logo.png"
                        alt="AI Trader Logo"
                    />
                </IconButton>

                {/* Menu button for mobile view */}
                <IconButton onClick={toggleNavMenu} sx={{ display: { sm: 'none' } }}>
                    <MenuIcon color='secondary' fontSize='medium' />
                </IconButton>

                {/* Navigation  for desktop  */}

                <List component="nav" sx={{ display: { xs: 'none', sm: 'flex', alignItems: 'center' } }}>
                    {pages.map(
                        (page, index) => {
                            const isActive = location.pathname === page.href
                            return (
                                <Box component={Link} to={page.href} key={index} sx={{ color: isActive ? '#00FBF4' : '#fff', textDecoration: 'none' }}>
                                    <NavBarListItem >
                                        {/* disableTypography- if I want to apply fontWeight here I must disable child element */}
                                        <ListItemText
                                            primary={page.name}
                                            disableTypography
                                            size='small'
                                            sx={{ fontSize: '13px', whiteSpace: 'nowrap', fontWeight: '500' }}
                                        />
                                    </NavBarListItem>
                                </Box>
                            )
                        }
                    )}
                    {autoComplete}
                </List>

                {/* Drawer for mobile */}
                <Drawer anchor="top" open={toggleMenu} onClose={toggleNavMenu} >
                    <IconButton onClick={toggleNavMenu} sx={{ padding: 4 }}>
                        <CloseIcon color='secondary' fontSize='medium' />
                    </IconButton>
                    <List component="nav" sx={{ marginLeft: 'auto', paddingBottom: '16px' }}>
                        {pages.map((page, index) => {
                            const isActive = location.pathname === page.href
                            return (
                                <Box component={Link} to={page.href} key={index} sx={{ color: isActive ? '#00FBF4' : '#fff', textDecoration: 'none' }}>
                                    <NavBarListItem onClick={toggleNavMenu} >
                                        <ListItemText primary={page.name} disableTypography size='small' placeholder="Search" sx={{ fontSize: '13px' }} />
                                    </NavBarListItem>
                                </Box>
                            )
                        })}
                        {autoComplete}
                    </List>
                </Drawer>
            </Toolbar>
        </AppBar>
    )
};

export default Navbar;